<template>

    <div class="navbar-container" v-if="$store.state.session.noticeDetails.bannerMessage">

        <nav class="navbar font-xs" :class="navClass" @click="navClick()" ref="bannerMessage">

            <div class="navbar-contents w-100">
                <div class="justify-content-center align-items-center font-weight-bold px-4" v-html="$store.state.session.noticeDetails.bannerMessage"> </div>
            </div>

        </nav>

    </div>

</template>

<script>
export default {
    data: function () {
        return {
            navClickObj: false,
            navbarClass: [],
        }
    },

    computed: {
            navClass: function() {
                let navClass = []

                switch(this.$store.state.session.noticeDetails.severity) {
                    case 'none':
                        navClass.push('bg-yellow')
                        navClass.push('text-dark')
                        break
                    case 'info':
                        navClass.push('position-fixed')
                        navClass.push('text-light')
                        navClass.push('bg-info')
                        break
                    case 'prim':
                        navClass.push('position-fixed')
                        navClass.push('text-light')
                        navClass.push('bg-primary')
                        break
                }

                return navClass
            }
        },

    methods: {
        navClick() {
            ga('send', {
                hitType: 'event',
                eventCategory: 'Navigation Bar',
                eventAction: 'Click',
                eventLabel: this.$refs.bannerMessage.innerText
            })

            let details = this.$store.state.session.noticeDetails

            if (details.onclick == 'modal') {
                this.$root.openModal(details.modal, details.data)
            } else if (details.onclick == 'redirect') {
                window.location.replace("exit?location=" + details.redirect)
            }
        },
    },
}
</script>

<style scoped>
    .navbar-container{
        height: 2.5rem;
    }
    .navbar {
        z-index: 1034 !important;
        height: inherit;
        right: 0;
        left: 0;
        max-width: 576px;
        margin-left: auto;
        margin-right: auto;
    }
    .navbar-contents >>> span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .navbar-contents >>> img {
        margin-right: 0.25rem;
        margin-left: 0.25rem;
    }
    .navbar-contents >>> div {
        display: -webkit-box !important;
        display: flex !important;
    }
    .navbar-contents >>> .n-item {
        -webkit-box-align: center !important;
        align-items: center !important;
    }
    .navbar-contents >>> .n-row {
        width: 100% !important;
        -webkit-box-pack: justify !important;
        justify-content: space-between !important;
    }
</style>
